const BRAND_ICON_BASE_PATH = "/images/brands";

/**
 * Converts a car-ref make label to the brand icon filename slug.
 */
export function slugifyCarMake(make: string): string {
  return make
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** Basenames of SVG files in public/images/brands/ (without extension). */
export const BRAND_ICON_SLUGS: ReadonlySet<string> = new Set([
  "alfa-romeo",
  "aro-png",
  "aston-martin",
  "audi",
  "avia",
  "bentley",
  "bmw",
  "bristol-png",
  "bugatti",
  "buick",
  "cadillac",
  "chatenet",
  "chevrolet",
  "chrysler",
  "citroen",
  "cupra",
  "dacia",
  "daewoo",
  "daewoo-avia",
  "daf",
  "daihatsu",
  "datsun",
  "dodge",
  "ferrari",
  "fiat",
  "ford",
  "gordon",
  "gumpert-png",
  "gwm",
  "holden",
  "honda",
  "hummer",
  "hyundai",
  "infiniti",
  "invicta",
  "isuzu",
  "iveco",
  "jaguar",
  "jeep",
  "kaipan-png",
  "kia",
  "knaus-png",
  "koenigsegg",
  "lada",
  "lamborghini",
  "lancia",
  "land-rover",
  "lexus",
  "liaz",
  "lincoln",
  "magma",
  "mahindra",
  "man",
  "maserati",
  "matra",
  "mazda",
  "mclaren",
  "mercedes-benz",
  "mg",
  "mini",
  "mitsubishi",
  "moskvič",
  "multicar",
  "nissan",
  "oltcit-png",
  "opel",
  "other-car",
  "peugeot",
  "pgo-png",
  "phanomen-png",
  "pontiac",
  "porsche",
  "praga",
  "renault",
  "rolls-royce",
  "rover",
  "saab",
  "saleen",
  "seat",
  "simca",
  "skoda",
  "smart",
  "ssangyong",
  "subaru",
  "suzuki",
  "tatra",
  "tesla",
  "toyota",
  "trabant",
  "venturi",
  "volkswagen",
  "volvo",
  "wartburg",
  "wiesmann",
]);

/**
 * Returns the public URL for a brand icon when an asset exists for the make.
 */
export function resolveBrandIconUrl(
  make: string | undefined | null,
): string | undefined {
  if (!make?.trim()) {
    return undefined;
  }
  const slug = slugifyCarMake(make);
  if (!BRAND_ICON_SLUGS.has(slug)) {
    return undefined;
  }
  return `${BRAND_ICON_BASE_PATH}/${slug}.svg`;
}
